/**
 * configuration load component
 * */

import React from 'react';
import LoadConfirm from "./LoadConfirm";
import {langSwitch} from "../../../../core/utils/lang";
import {useParams} from "react-router-dom";
import useLoadMyOneOfOne from "../../../hooks/core/useLoadMyOneOfOne";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import callPeerRemoteModule from "../../../../core/utils/callPeerRemoteModule";
import {confLoad} from "../../../../core/api/configuratorApi";
import {loadDataAndSet} from "../../../redux/optionWindow-slice/optionWindowSlice";
import {introAction, menuAction} from "../../../redux/store";
import Confirm from "../../designHistory/component/molecules/Confirm";

const LoadComponent = ({componentMount, vehicleSelectHandler, closeModal, closeSubModal, subModalMount}) => {

  const params = useParams();
  const {initialValue, codeInputRefs, getEntireCodeFromInput, keyDownHandler, onInputHandler} = useLoadMyOneOfOne();

  const dispatch = useDispatch();

  const {connectMode} = useSelector(state => ({
    connectMode: state.theme.connectMode,
  }), shallowEqual);



  const submit = async (bespokeCode) => {
    const peer = await callPeerRemoteModule(connectMode);
    const configLoadResponse = await confLoad(bespokeCode);


    if (configLoadResponse.data.result && configLoadResponse.data.message === "SUCCESS") {
      const configData = configLoadResponse.data.data.config_data;
      const productCode = configLoadResponse.data.data.productCode || "";
      const loadMyDesign = true;

      if(!peer) {
        const setConfig = new Promise(resolve => {
          // resolve(dispatch(optionAction.setLoadData(configData)));
          resolve(dispatch(loadDataAndSet({ processedData: configData, colorway: configData.COLORWAY})));
          dispatch(introAction.setLoadingState("loading"));
        });
        setConfig.then(() => {
          setTimeout(() => {
            window.location.href = `/en/${productCode.toLowerCase()}/configurator/exterior`
          },100)
        });


      } else if (peer) {
        const setConfig = new Promise(resolve => {
          resolve(dispatch(loadDataAndSet({ processedData: configData, colorway: configData.COLORWAY})));
        });
        setConfig.then(() => {
          setTimeout(() => {
            vehicleSelectHandler(productCode, connectMode, configData);
            peer.conn.sendData("dispatch", {action: "introAction", func: "setLoadingState", payload: "wait"});
          }, 100)
        });
      }

      dispatch(menuAction.menuToggle());
      closeSubModal();
      // dispatch(modalAction.modalClose());

    } else {
      componentMount(<>
        <div className={"modal-body"}>
          <h2>Failed</h2>
          <p>Configuration data does not exist.</p>
        </div>
        <div className={"modal-footer"}>
          <button type={"button"} className={"btn notheme"} data-block data-size={"lg"} onClick={() => {
            dispatch(menuAction.menuToggle());
            closeSubModal();
            // dispatch(modalAction.modalClose());
          }}>
            <span>Close</span>
          </button>
        </div>
      </>);
    }
  }









  return (
    <>
      <div className={"modal-header"}>
        <h2>{langSwitch("loadConfig", "title", params.lang)}</h2>
        <button type="button" className="modal-close" onClick={closeModal}>close
        </button>
      </div>

      <div className={"modal-body"}>
        <p>
          {langSwitch("loadConfig", "subTitle", params.lang).split("\n").map((title, index) => {
            return (
              <React.Fragment key={index}><span>{title}</span><br/></React.Fragment>
            )
          })}
        </p>

        <div className={"save-load"}>
          <div className="form-group" id="EnterCode">
            <label>{langSwitch('loadConfig', 'codeLabel', params.lang)}</label>
            <div className="form">
              {
                initialValue.map((item, index) => {
                  return (
                    <input
                      key={index}
                      ref={codeInputRefs.current[index]}
                      type={"text"}
                      data-box
                      maxLength={1}
                      onKeyDown={(e) => keyDownHandler(e, index)}
                      onInput={(e) => onInputHandler(e, index)}
                    />
                  )
                })
              }

            </div>
            <button
              type="button" className="btn notheme"
              data-block="" data-intent="confirm" data-size="lg"
              onClick={() => {
                const myCode = getEntireCodeFromInput();
                subModalMount(
                //   <LoadConfirm
                //     bespokeCode={myCode}
                //     componentMount={componentMount}
                //     vehicleSelectHandler={vehicleSelectHandler}
                //     closeSubModal={closeSubModal}
                // />, true
                  <Confirm
                    title={"Are you sure you want to load the code?"}
                    message={"The values configured so far are replaced"}
                    callback={() => submit(myCode)}
                    closeModal={closeModal}
                    closeSubModal={closeSubModal}
                  />, true
                )

              }}
            >
              <span>{langSwitch('loadConfig', 'loadButton', params.lang)}</span>
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default LoadComponent;
